import React, { createContext, useContext, useState } from 'react';

const FilterContext = createContext();

export const useFilter = () => {
    const context = useContext(FilterContext);
    if (!context) {
        throw new Error('useFilter must be used within a FilterProvider');
    }
    return context;
};

export const FilterProvider = ({ children }) => {
    const [isFilterPopupOpen, setIsFilterPopupOpen] = useState(false);

    const openFilterPopup = () => {
        setIsFilterPopupOpen(true);
    };

    const closeFilterPopup = () => {
        setIsFilterPopupOpen(false);
    };

    const toggleFilterPopup = () => {
        setIsFilterPopupOpen(!isFilterPopupOpen);
    };

    return (
        <FilterContext.Provider value={{
            isFilterPopupOpen,
            openFilterPopup,
            closeFilterPopup,
            toggleFilterPopup
        }}>
            {children}
        </FilterContext.Provider>
    );
};

